import { IntegrationCard } from "./integration_card";
import type IntegrationProvider from "../models/integrationProvider";
import type IntegrationSetupDto from "../../integration_setup/models/IntegrationSetup";
import GlassContainer from "@/shared/components/glasscontainer";

export interface IntegrationsGridProps {
  integrations: IntegrationProvider[];
  setupsMap: Map<string, IntegrationSetupDto>;
  loading: boolean;
  error: Error | null;
  onDeleteProvider: (id: string) => void;
  onToggleGlobal?: (id: string) => void;
  onTestSetup: (providerId: string) => void;
}

export function IntegrationsGrid({
  integrations,
  setupsMap,
  loading,
  error,
  onDeleteProvider,
  onToggleGlobal,
  onTestSetup,
}: IntegrationsGridProps) {
  if (error) {
    return (
      <GlassContainer className="p-6 mb-6 border-l-4 border-red-500 bg-red-500/5">
        <p className="text-red-700 font-medium">
          Error al cargar integraciones
        </p>
        <p className="text-red-600/80 text-sm mt-1">{error.message}</p>
      </GlassContainer>
    );
  }

  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-6">
        {Array.from({ length: 6 }).map((_, i) => (
          <GlassContainer key={i} className="h-64 animate-pulse bg-white/20" />
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Add new integration card */}

      {/* Integrations grid */}
      {integrations.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {integrations.map((integration) => (
            <IntegrationCard
              key={integration.id}
              integration={integration}
              setup={setupsMap.get(integration.id)}
              onDeleteProvider={onDeleteProvider}
              onToggleGlobal={onToggleGlobal}
              onTestSetup={onTestSetup}
            />
          ))}
        </div>
      ) : (
        <GlassContainer className="p-12 flex flex-col items-center justify-center text-center">
          <div className="w-16 h-16 rounded-full bg-accent/10 flex items-center justify-center mb-4">
            <svg
              className="w-8 h-8 text-accent/50"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.658 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1"
              />
            </svg>
          </div>
          <h3 className="text-lg font-semibold text-foreground mb-2">
            No hay proveedores de integraciones
          </h3>
        </GlassContainer>
      )}
    </div>
  );
}
